import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { TooltipPropsWithTitle } from 'antd/es/tooltip';
import { ReactElement } from 'react';

interface Props extends TooltipPropsWithTitle {
    icon?: ReactElement;
    onClick?: () => void;
}

const IconTooltip = ({ icon, children, onClick, ...rest }: Props) => {
    return (
        <Tooltip {...rest}>
            <span
                style={{
                    display: 'flex',
                    alignItems: 'center',
                }}
                role="tooltip"
                onClick={onClick}
            >
                {icon ? (
                    icon
                ) : (
                    <InfoCircleOutlined
                        style={{
                            color: 'var(--gray-9)',
                        }}
                    />
                )}
                {children}
            </span>
        </Tooltip>
    );
};

export default IconTooltip;
